
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicTicketTypesApi extends BaseModulePublicApi{
  basePath = 'tickets_types';
};
